export const PlayerReportTypes = {
    PLAYER_REPORT_REQUEST: 'PLAYER_REPORT_REQUEST',
    PLAYER_REPORT_SUCCESS: 'PLAYER_REPORT_SUCCESS',
    PLAYER_REPORT_FAILED: 'PLAYER_REPORT_FAILED',
    //OLD
    OLD_PLAYER_REPORT_REQUEST: 'OLD_PLAYER_REPORT_REQUEST',
    OLD_PLAYER_REPORT_SUCCESS: 'OLD_PLAYER_REPORT_SUCCESS',
    OLD_PLAYER_REPORT_FAILED: 'OLD_PLAYER_REPORT_FAILED',

    PLAYER_REPORT_SORT: 'PLAYER_REPORT_SORT',
    PROMOTION_DATA_REQUEST: 'PROMOTION_DATA_REQUEST',
    PROMOTION_DATA_SUCCESS: 'PROMOTION_DATA_SUCCESS',
    PROMOTION_DATA_FAILED: 'PROMOTION_DATA_FAILED',
    PLAYER_CAMPAIGNS_DATA_REQUEST: 'PLAYER_CAMPAIGNS_DATA_REQUEST',
    PLAYER_CAMPAIGNS_DATA_SUCCESS: 'PLAYER_CAMPAIGNS_DATA_SUCCESS',
    PLAYER_CAMPAIGNS_DATA_FAILED: 'PLAYER_CAMPAIGNS_DATA_FAILED',
    
    // Filter actions
    SET_ROUND_ID: 'SET_ROUND_ID',
    SET_DATE_RANGE: 'SET_DATE_RANGE',
    SET_ROUND_TYPES: 'SET_ROUND_TYPES',
    SET_SORT: 'SET_SORT',
    SET_PAGINATION: 'SET_PAGINATION',
    CLEAR_ROUND_ID: 'CLEAR_ROUND_ID',
    CLEAR_DATE_FILTER: 'CLEAR_DATE_FILTER',
    RESET_FILTERS: 'RESET_FILTERS',
    INIT_FILTERS_FROM_URL: 'INIT_FILTERS_FROM_URL',
    CLEAR_PLAYER_DATA: 'CLEAR_PLAYER_DATA',
};

export const getPlayerReport = (payload?: any) => ({
    type: PlayerReportTypes.PLAYER_REPORT_REQUEST,
    payload,
});
export const playerReportSuccess = (payload?: any) => ({
    type: PlayerReportTypes.PLAYER_REPORT_SUCCESS,
    payload,
});
export const OLDgetPlayerReport = (payload?: any) => ({
    type: PlayerReportTypes.OLD_PLAYER_REPORT_REQUEST,
    payload,
});
export const OLDplayerReportSuccess = (payload?: any) => ({
    type: PlayerReportTypes.OLD_PLAYER_REPORT_SUCCESS,
    payload,
});
export const playerReportSort = (payload?: any) => ({
    type: PlayerReportTypes.PLAYER_REPORT_SORT,
    payload,
});
export const getPromotionData = (payload?: any) => ({
    type: PlayerReportTypes.PROMOTION_DATA_REQUEST,
    payload,
});
export const promotionDataSuccess = (payload?: any) => ({
    type: PlayerReportTypes.PROMOTION_DATA_SUCCESS,
    payload,
});
export const getPlayerPromotionsData = (payload?: any) => ({
    type: PlayerReportTypes.PLAYER_CAMPAIGNS_DATA_REQUEST,
    payload,
});
export const getPlayerPromotionsDataSuccess = (payload?: any) => ({
    type: PlayerReportTypes.PLAYER_CAMPAIGNS_DATA_SUCCESS,
    payload,
});

// Filter actions
export const setRoundId = (roundId: string | null) => ({
    type: PlayerReportTypes.SET_ROUND_ID,
    payload: { roundId },
});

export const setDateRange = (fromDate: any, toDate: any) => ({
    type: PlayerReportTypes.SET_DATE_RANGE,
    payload: { fromDate, toDate },
});

export const setRoundTypes = (roundTypes: string[]) => ({
    type: PlayerReportTypes.SET_ROUND_TYPES,
    payload: { roundTypes },
});

export const setSort = (sortBy: string, sortOrder: 'ASCENDING' | 'DESCENDING') => ({
    type: PlayerReportTypes.SET_SORT,
    payload: { sortBy, sortOrder },
});

export const setPagination = (currentPage: number, pageSize?: number) => ({
    type: PlayerReportTypes.SET_PAGINATION,
    payload: { currentPage, pageSize },
});

export const clearRoundId = () => ({
    type: PlayerReportTypes.CLEAR_ROUND_ID,
});

export const clearDateFilter = () => ({
    type: PlayerReportTypes.CLEAR_DATE_FILTER,
});

export const resetFilters = () => ({
    type: PlayerReportTypes.RESET_FILTERS,
});

export const initFiltersFromURL = (filters: any) => ({
    type: PlayerReportTypes.INIT_FILTERS_FROM_URL,
    payload: { filters },
});

export const clearPlayerData = () => ({
    type: PlayerReportTypes.CLEAR_PLAYER_DATA,
});
